import React, { useState } from "react";
import { exchangeBrand } from "@/lib/exchange-brand";

interface ExchangeLogoProps {
  code: string;
  /** Pixel size of the round logo. */
  size?: number;
  className?: string;
}

/** Round exchange logo; falls back to the first letter when we have no image. */
export const ExchangeLogo: React.FC<ExchangeLogoProps> = ({
  code,
  size = 24,
  className = "",
}) => {
  const brand = exchangeBrand(code);
  const [failed, setFailed] = useState(false);
  const style = { width: size, height: size };

  if (!brand.logo || failed) {
    return (
      <span
        style={{ ...style, fontSize: Math.max(8, size * 0.42) }}
        className={`flex shrink-0 items-center justify-center rounded-full bg-[#262626] font-semibold text-[#d4d4d4] ${className}`}
        title={brand.name}
      >
        {brand.name[0]}
      </span>
    );
  }
  return (
    <img
      src={brand.logo}
      alt={brand.name}
      title={brand.name}
      style={style}
      onError={() => setFailed(true)}
      className={`shrink-0 rounded-full bg-[#171717] object-contain ${className}`}
    />
  );
};
